import React from "react";
import { Card } from "react-bootstrap";
import Student from "../../Assets/Images/posp-student.png"
import Spouse from "../../Assets/Images/stay-at-home.png"
import Businessman from "../../Assets/Images/posp-man.png"
import OldMan from "../../Assets/Images/posp-oldman.png"


const WhoCanBeAPosp = () => {
  return (
    <div className="container mt-5 ">
      <div className="row d-flex align-items-center justify-content-center">
        <div className="col-md-5 col-sm-12 text-start ">
          <h2 style={{ color: "#1f2c6a" }}>Who can Become PoSP</h2>
          <div >
            1. Must be over 18 years of age.
            <br />
            2. Should have completed their education up to Class 10th at least.
            <br />
            3. Valid Aadhar Card and PAN Card is required.
          </div>
        </div>
        <div className="col-md-7  col-sm-12">
          <div className=" row gap-3 align-items-center justify-content-center becomePosp-card-div">
            <Card
              className="user-card col-md-6 d-flex align-items-center justify-content-center"
            >
              <div >
                <Card.Img
                  variant="top"
                  src={Student}
                  className="user-img"
                  style={{ width: "160px" }}
                />
                <Card.Title className="user-name text-center mt-3">College student</Card.Title>

                <Card.Text className="user-description ">
                  <h4 className="pb-2 description-name"> College student</h4>
                  <h6>
                    If you’re pursuing your higher studies but would still want
                    to spend some time making extra money, this could be
                    a good option for you.
                  </h6>
                </Card.Text>
              </div>
            </Card>
            <Card
              className="user-card col-md-6 d-flexalign-items-center justify-content-center"
              style={{ marginTop: "-36px" }}
            >
              <div
                className="card-body d-flex align-items-center justify-content-center flex-column gap-4"
              >
                <Card.Img
                  variant="top"
                  src={Spouse}
                  className="user-img"
                  style={{ width: "160px" }}
                />
                <Card.Title className="user-name text-center ">
                  Stay at home spouses
                </Card.Title>

                <Card.Text className="user-description ">
                  <h4 className="pb-2 description-name">
                    {" "}
                    Stay at home spouses
                  </h4>
                  <h6>
                    If you’re a stay at home husband or wife, and have time, you
                    can choose to become a PoSP, and earn extra income for you
                    and your family
                  </h6>
                </Card.Text>
              </div>
            </Card>
            <Card
              className="user-card col-md-6 d-flex align-items-center justify-content-center"
            >
              <div
                className="card-body d-flexalign-items-center justify-content-center flex-column gap-4"
              >
                <Card.Img
                  variant="top"
                  src={Businessman}
                  className="user-img"
                  style={{ width: "160px" }}
                />
                <Card.Title
                  className="user-name text-center mt-3 "
                >
                Entrepreneur
                </Card.Title>

                <Card.Text className="user-description ">
                  <h4 className="pb-2 description-name">Entrepreneur</h4>
                  <h6>
                    If you’re already have a business but still want to do more
                    things on the side, you can choose to become a PoSP. Work
                    just as much as you want, and still earn extra.
                  </h6>
                </Card.Text>
              </div>
            </Card>
            <Card
              className="user-card col-md-6 d-flexalign-items-center justify-content-center"
              style={{ marginTop: "-36px" }}>
              <div className="card-body d-flex align-items-center justify-content-center flex-column gap-4">
                <Card.Img
                  variant="top"
                  src={OldMan}
                  className="user-img"
                  style={{ width: "160px" }}
                />
                <Card.Title className="user-name text-center " >
                  Retirees
                </Card.Title>

                <Card.Text className="user-description ">
                  <h4 className="pb-2 description-name"> Retirees</h4>
                  <h6>
                    Even after retirement, you can become an insurance agent.
                    Spend as much time as you like, working in the comfort of
                    your home, and at any time you like.
                  </h6>
                </Card.Text>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoCanBeAPosp;
